import React, { useState, useEffect } from 'react';
import api from '../services/api';

const fmt = n => Number(n || 0).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const statusBadge = s => {
  const map = { Paid: 'badge-green', Unpaid: 'badge-orange', Overdue: 'badge-red', Partial: 'badge-blue' };
  return <span className={`badge ${map[s] || 'badge-gray'}`}>{s}</span>;
};

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get('/dashboard').then(r => setData(r.data)); }, []);

  if (!data) return <div className="loading"><div className="spinner"></div></div>;
  const { stats, barangay_stats, recent_bills } = data;

  return (
    <div>
      <h1 className="page-title">Dashboard</h1>
      <div className="stat-grid">
        <div className="stat-card"><div className="stat-value" style={{color:'#1976d2'}}>{stats.total_consumers}</div><div className="stat-label">Active Consumers</div></div>
        <div className="stat-card"><div className="stat-value" style={{color:'#ef6c00'}}>PHP {fmt(stats.total_receivables)}</div><div className="stat-label">Total Receivables</div></div>
        <div className="stat-card"><div className="stat-value" style={{color:'#2e7d32'}}>PHP {fmt(stats.total_collected)}</div><div className="stat-label">Total Collected</div></div>
        <div className="stat-card"><div className="stat-value" style={{color:'#d32f2f'}}>{stats.overdue_bills}</div><div className="stat-label">Overdue Bills</div></div>
      </div>

      <h3 style={{ margin: '24px 0 12px' }}>Consumers per Barangay</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12 }}>
        {barangay_stats.map(b => (
          <div key={b.name} className="card" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 16 }}>
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#e3f2fd', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1976d2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13, color: '#333' }}>{b.name}</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#1976d2' }}>{b.count}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <h3>Recent Bills</h3>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Consumer</th><th>Barangay</th><th>Period</th><th className="text-right">Amount</th><th>Status</th></tr></thead>
            <tbody>
              {recent_bills.map(b => (
                <tr key={b.id}><td>{b.consumer_name}</td><td>{b.barangay}</td><td>{b.billing_period}</td><td className="text-right">PHP {fmt(b.total_amount)}</td><td>{statusBadge(b.status)}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
